module.exports = __webpack_public_path__ + "static/media/payme.9999860f.jpg";